import StandardTable from "../../components/reusables/StandardTable";
import FormEditLink from "../../components/reusables/FormEditLink";
import SsnReportField from "../../components/reusables/SsnReportField";

export default {
  'shared-form-preview': StandardTable,
  'creator_id': FormEditLink,
  'ssn': SsnReportField
}



// WEBPACK FOOTER //
// ./src/utils/specialReportColumnTypeComponents/index.js